import { ref } from 'vue'

import { SaveSourceMediumFlow } from '../flows/SaveSourceMediumFlow'

import { useWorkspaceAttribute } from '@/features/workspace-settings'

export function useSourceMedium(platform: string, flow = new SaveSourceMediumFlow()) {
  const sourceKey: `${string}_utm_sources` = `${platform}_utm_sources`
  const mediumKey: `${string}_utm_mediums` = `${platform}_utm_mediums`
  const sources = useWorkspaceAttribute(sourceKey)
  const mediums = useWorkspaceAttribute(mediumKey)
  const pending = ref(false)
  const error = ref<unknown>(null)

  async function save(nextSources: readonly string[], nextMediums: readonly string[]) {
    pending.value = true
    error.value = null
    try {
      return await flow.save(platform, nextSources, nextMediums, {
        source: sources.id.value,
        medium: mediums.id.value,
      })
    } catch (cause) {
      error.value = cause
      return null
    } finally {
      pending.value = false
    }
  }

  return { sources, mediums, pending, error, save }
}
